
export default function navigator ({from, next, store, to }){ 
    if(store.getters.getAuthenticated){
        setTimeout(()=>{
            store.commit('setCurrenttRoute', to)
        },100)
        return next()
    }else{
        store.commit('setCurrenttRoute', '/auth')
        return next('/auth')
    }
}